module.exports = __webpack_public_path__ + "img/ellipse-texture.103b2d9d.svg";